"use client";
import { IconCopy } from "@tabler/icons-react";
import CopyButton from "../../../components/CopyButton";

type Props = {
  webhookUrl: string;
  tab: string;
};

const SectionHeader = ({ icon: Icon, title }: { icon: any; title: string }) => (
  <div className="flex items-center gap-2 border-b border-[#FBD037]/30 pb-2 mb-3">
    <div className="p-1.5 rounded-lg bg-[#FBD037]/20">
      <Icon size={16} className="text-[#212121]" stroke={1.5} />
    </div>
    <p className="text-[#212121]/80 uppercase text-[11px] font-bold tracking-wide">
      {title}
    </p>
  </div>
);

const WebhookModal = ({ webhookUrl, tab }: Props) => {
  return (
    <div className="group  rounded-2xl bg-gradient-to-b from-white/90 to-white/60 backdrop-blur-xl border border-[#D2D2D2]/70 p-4 transition-all duration-300 space-y-3">
      <div className="absolute inset-0 rounded-3xl bg-gradient-to-tr from-yellow-200/20 to-transparent pointer-events-none" />
      <SectionHeader
        icon={IconCopy}
        title={`Copy this webhook URL and paste it in your ${tab} account`}
      />
      <div className="space-y-4">
        <div className="flex items-center justify-between gap-2 bg-white py-0.5 px-2 border border-[#D2D2D2] rounded">
          <span className="truncate">{webhookUrl}</span>
          <CopyButton text={webhookUrl} />
        </div>
      </div>
    </div>
  );
};

export default WebhookModal;
